import Vue from 'vue';
import App from './App.vue';
import router from './router'; 
import axios from 'axios';

Vue.config.productionTip = false;
Vue.config.devtools = false;
Vue.prototype.$axios = axios; 

axios.defaults.baseURL = 'https://metricwsback.cwp.mx/api'; 
// axios.defaults.baseURL = 'http://127.0.0.1:8000/api';
// axios.defaults.baseURL = 'https://metricwsback.allegrazoe.com/api'; 
axios.defaults.headers.common['Accept'] = 'application/json';

axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const isNetworkError = error.message === "Network Error";
    const isCorsError = status === undefined && error.code === "ERR_NETWORK";

    const shouldLogout = (status === 401 || status === 403 || isNetworkError || isCorsError);

    if (shouldLogout) {
      console.warn("🔐 Token inválido o error de red. Cerrando sesión...");
      localStorage.removeItem("token");
      localStorage.removeItem("user_role");
      localStorage.removeItem("user_id");
      localStorage.setItem("expiredSession", "true");

      if (window.location.pathname !== "/") {
        window.location.href = "/";
      } else {
        window.location.reload();
      }

      return Promise.reject("Sesión inválida o caída de red.");
    }

    return Promise.reject(error);
  }
);

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
